// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","airplane":"airplane-3UYWS","details":"details-2aKmc","sunInfo":"sunInfo-a3aQ_","seatDetails":"seatDetails-2mj78"};